import React from 'react';

import ITag from 'shared/model/ITags';

import TagsModal from '../TagsModal/TagsModal';

interface IMonitorTagsModalProps {
    open: boolean,
    uuid?: string,
    tags?: (ITag | string)[],
    dialogClassName?: string,
    handleClose: () => void,
    // eslint-disable-next-line no-unused-vars
    useUpdateTags: (uuid: string | undefined) => (tags: string[]) => Promise<void>,
}

const MonitorTagsModal: React.FC<IMonitorTagsModalProps> = ({
    open,
    uuid,
    tags,
    dialogClassName,
    handleClose,
    useUpdateTags,
}) => {
    const handleSave = useUpdateTags(uuid);

    return (
        <TagsModal
            open={open}
            tags={tags}
            dialogClassName={dialogClassName}
            handleClose={handleClose}
            onSave={handleSave}
        />
    );
};

export default MonitorTagsModal;
